'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseResizableDirectiveController=require('../../../../../../dist-es6/client/angularCommon/baseResizableDirectiveController');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');

const YAxisWidth=70;
const YAxisLabelLeftMargin=5;

const XAxisHeight=50;
const XAxisTopMargin=10;
const XAxisLabelHeight=15;
const XAxisLabelBottomMargin=15;

const RightMargin=10;

const PixelsBetweenRows=5;
const PixelsBetweenColumns=5;

const MinAllowedBoxHeight=30;let

HistogramPlotterDirective=function(_BaseControllerBacked){_inherits(HistogramPlotterDirective,_BaseControllerBacked);function HistogramPlotterDirective(){_classCallCheck(this,HistogramPlotterDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(HistogramPlotterDirective,[{key:'objectBindings',get:function()
{
return['group'];
}},{key:'controller',get:function()

{
return HistogramPlotterDirectiveController;
}}]);return HistogramPlotterDirective}(BaseControllerBackedDirective);let


HistogramPlotterDirectiveController=function(_BaseResizableDirecti){_inherits(HistogramPlotterDirectiveController,_BaseResizableDirecti);_createClass(HistogramPlotterDirectiveController,null,[{key:'$inject',get:function()
{
return['$scope','$element','$window'];
}}]);

function HistogramPlotterDirectiveController($scope,$element,$window){_classCallCheck(this,HistogramPlotterDirectiveController);var _this2=_possibleConstructorReturn(this,
_BaseResizableDirecti.call(this,$scope,$element,$window));

_this2._svgElement=null;

$scope.$watch('controller.group',function(newGroup,oldGroup){
if(_.exists(_this2.group)){
_this2._redraw();
}
});return _this2;
}HistogramPlotterDirectiveController.prototype.

_onDimensionsChanged=function _onDimensionsChanged(newDimensions,oldDimensions){
this._redraw();
};HistogramPlotterDirectiveController.prototype.













_redraw=function _redraw(){var _this3=this;
if(_.exists(this._svgElement)){
angular.element(this._svgElement).remove();
}

if(!this._dimensionsValid||!_.exists(this.group)){
return;
}

this._$element.append(`<svg width="${this.dimensions.width}" height="${this.dimensions.height}"></svg>`);
this._svgElement=this._$element[0].getElementsByTagName('svg')[0];

let numDisplayedRows=Math.max.apply(Math,[1].concat(_toConsumableArray(this.group.fatigueDistribution.bins.map(function(bin){return bin.length}))));
let plottableWidth=this.dimensions.width-YAxisWidth-RightMargin;

let xScale=d3.scale.linear().
domain([this._firstBinStart-.5*this._binSize,this._firstBinStart+(this._totalBins-.5)*this._binSize]).
range([0,plottableWidth]);

let yScale=d3.scale.linear().
domain([.5,numDisplayedRows+.5]).
range([this.dimensions.height-(XAxisHeight+XAxisTopMargin+XAxisLabelBottomMargin),0]);

let xAxis=d3.svg.axis().scale(xScale).orient('bottom').ticks(this._totalBins);
let yAxis=d3.svg.axis().scale(yScale).orient('left').ticks(Math.min(10,numDisplayedRows));

let svgContainer=d3.select(this._svgElement);

svgContainer.append('g').
attr({
class:'x-axis',
transform:`translate(${YAxisWidth}, ${this.dimensions.height-(XAxisHeight+XAxisTopMargin+XAxisLabelBottomMargin)})`}).
call(xAxis);
let ticks=svgContainer.append('g').attr({class:'y-axis',transform:`translate(${YAxisWidth}, 0)`}).call(yAxis);
try{

let lastTick=_.last(ticks.selectAll('.tick')[0]);
let rawTransform=d3.select(lastTick).attr('transform');

let yTransform=parseFloat(rawTransform.split('translate(0')[1].slice(1).split(')')[0]);
if(yTransform<15){
d3.select(lastTick).attr('visibility','hidden');
}
}catch(e){

}

svgContainer.append('text').
attr({
class:'axis-label',
transform:'rotate(-90)',
y:YAxisLabelLeftMargin,
x:-((this.dimensions.height-(XAxisTopMargin+XAxisLabelBottomMargin+XAxisLabelHeight))/2),
dy:'1em',
"text-anchor":'middle'}).

text('# Days');

svgContainer.append('text').
attr({
class:'axis-label',
x:YAxisWidth+plottableWidth/2,
y:this.dimensions.height-(XAxisTopMargin+XAxisLabelBottomMargin+XAxisLabelHeight),
dy:'1em',
"text-anchor":'middle'}).

text('Fatigue');

let widthOfOneBinOnScreen=xScale(1)-xScale(0);
let heightOfOneCountOnScreen=yScale(0)-yScale(1);
let drawIndividualBoxes=heightOfOneCountOnScreen>=MinAllowedBoxHeight;
if(!drawIndividualBoxes){
var getYandHeightForCombinedRows=function(count){return{
y:yScale(count+.5),
height:heightOfOneCountOnScreen*count}};

}

if(drawIndividualBoxes){
for(let rowIndex=0;rowIndex<numDisplayedRows;rowIndex++){
svgContainer.append('rect').
attr({
class:'backdrop',
x:YAxisWidth,
y:yScale(rowIndex+1.5)+PixelsBetweenRows,
width:plottableWidth,
height:heightOfOneCountOnScreen-PixelsBetweenRows});

}
}else{
let{y:y,height:height}=getYandHeightForCombinedRows(numDisplayedRows);
svgContainer.append('rect').
attr({
class:'backdrop',
x:YAxisWidth,
y:y,
width:plottableWidth,
height:height});

}

this.group.fatigueDistribution.bins.forEach(function(bin,binIndex){
let binValue=_this3._firstBinStart+binIndex*_this3._binSize;
let xPosition=YAxisWidth+xScale(binValue-0.5*_this3._binSize)+PixelsBetweenColumns;

let binThresholdStatus=ThresholdStatus.fromScoreAndThreshold(binValue,_this3.group.fatigueThreshold);
let itemRectClass='nominal';
switch(binThresholdStatus){
case ThresholdStatus.Above:
itemRectClass='alert';
break;
case ThresholdStatus.At:
itemRectClass='warn';
break;}


let width=widthOfOneBinOnScreen-PixelsBetweenColumns;

if(width<=0){
return;
}

if(drawIndividualBoxes){
bin.forEach(function(item,itemIndex){
let height=heightOfOneCountOnScreen-PixelsBetweenRows;

if(height<=0){
return;
}

svgContainer.append('rect').
attr({
class:itemRectClass,
x:xPosition,
y:yScale(itemIndex+1.5)+PixelsBetweenRows,
width:width,
height:height});

});
}else if(bin.length>0){
let{y:y,height:height}=getYandHeightForCombinedRows(bin.length);

if(height<=0){
return;
}

svgContainer.append('rect').
attr({
class:itemRectClass,
x:xPosition,
y:y,
width:width,
height:height});

}
});
};_createClass(HistogramPlotterDirectiveController,[{key:'_binSize',get:function(){return this.group.fatigueDistribution.binSize}},{key:'_firstBinStart',get:function(){return this.group.fatigueDistribution.start}},{key:'_totalBins',get:function(){return this.group.fatigueDistribution.bins.length}}]);return HistogramPlotterDirectiveController}(BaseResizableDirectiveController);


module.exports=HistogramPlotterDirective;
//# sourceMappingURL=histogramPlotterDirective.js.map
